import type { ButtonPropsWithLabel } from 'src/components/Dialog';

export type BlockingReasonVariant = 'checkin' | 'booking';

export type CheckinBlockerReasonType =
  | 'paymentRequired'
  | 'billing_blocked'
  | 'waiverRequired'
  | 'waiver_required'
  | 'formsBlocked'
  | 'forms_blocked'
  | 'custom';

export type CheckinBlocker = {
  type: CheckinBlockerReasonType;
  title?: string;
  message?: string;
  resolved?: boolean;
  resolvedBy?: 'payment' | 'override';
  documentUrl?: string;
  unsignedDocumentCount?: number;
};

export type CheckinBlockerUser = {
  id?: string;
  name?: string;
  profileImage?: string;
  blockers: CheckinBlocker[];
};

export type CheckinBlockerOverrideScope = 'all' | 'user' | 'blocker';

export type CheckinBlockerOverrideContext = {
  scope: CheckinBlockerOverrideScope;
  user?: CheckinBlockerUser;
  blocker?: CheckinBlockerUser['blockers'][number];
  blockerIndex?: number;
};

/** Session context passed from Ember booking into the check-in blocker embed. */
export type CheckinBlockerSessionDetails = {
  serviceName: string;
  startTime: number;
  duration?: number;
  trainerNames?: string;
  locationName?: string;
  locationAddress?: string;
  locationInstructions?: string;
  resourceInstructions?: string;
  imageUrl?: string;
  serviceDescription?: string;
  attendeeCount?: number;
};

export interface CheckinBlockerContentProps {
  users: CheckinBlockerUser[];
  sessionDetails?: CheckinBlockerSessionDetails;
  showUserDetails?: boolean;
  blockingReasonVariant?: BlockingReasonVariant;
  onOverride?: (context: CheckinBlockerOverrideContext) => void | Promise<void>;
  onBillingResolved?: (userId: string) => void;
  /** Stretch content to fill the iframe viewport (booking embeds). */
  fillAvailableSpace?: boolean;
}

export type BlockingReasonLinkAction = {
  kind: 'link';
  label: string;
  onClick: () => void;
};

export type BlockingReasonButtonAction = ButtonPropsWithLabel & {
  kind?: 'button';
};

export type BlockingReasonAction =
  | BlockingReasonLinkAction
  | BlockingReasonButtonAction;

export function isBlockingReasonLinkAction(
  action: BlockingReasonAction
): action is BlockingReasonLinkAction {
  return action.kind === 'link';
}

